const preloaded = window.maichSwift || {}

export default {
  title: preloaded.title,
  description: preloaded.description,
  projectList: preloaded.projectList || [],
  experienceList: preloaded.experienceList || [],
  projects: projectSlugs(),
  currentProject: {},
  news: preloaded.news || [],

  pages: {
    home: preloaded.homepage || {}
  },
  currentPage: {},
  posts: [],

  introVisible: true
}

function projectSlugs () {
  const keyed = {}
  preloaded.projectList.forEach((p) => {
    keyed[p.post_name] = p
  })

  return keyed
}



// WEBPACK FOOTER //
// ./src/store/state.js